import IconPin from "@/components/icons/icon-pin";

interface ReviewPinnedSelectionSummaryProps {
	pinnedCount: number;
	maxReviews?: number;
	onClick: () => void;
	disabled?: boolean;
}

export default function ReviewPinnedSelectionSummary({ pinnedCount, maxReviews, onClick, disabled = false }: ReviewPinnedSelectionSummaryProps) {
	const visibleCount = maxReviews != null ? Math.min(pinnedCount, maxReviews) : pinnedCount;

	return (
		<button
			type="button"
			onClick={onClick}
			disabled={disabled}
			className={`w-full p-4 rounded-xl border border-gray-200 text-left transition-all ${disabled ? "opacity-50 cursor-not-allowed" : "hover:border-gray-300 hover:bg-gray-50 cursor-pointer"}`}
		>
			{/* Counts row */}
			<div className="flex items-center gap-2 mb-2">
				<IconPin />
				<span className="text-sm font-medium text-gray-900">
					{pinnedCount} pinned
					<span className="text-tertiary font-normal"> · {visibleCount} visible</span>
				</span>
			</div>

			{/* Filter summary row */}
			<div className="flex flex-col gap-2">
				<span className="text-sm text-tertiary truncate pr-2">Pinned reviews always show on top of page.</span>

				<span className="text-sm font-medium text-gray-600 flex items-center gap-1 shrink-0">
					Select
					<svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
						<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
					</svg>
				</span>
			</div>
		</button>
	);
}
